<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <div class="tbl-scroll-host">
      <el-table :data="tableData" v-loading="listLoading" style="width: 100%; margin-top: 20px;" height="100%">
        <el-table-column prop="Name" label="管理员姓名" min-width="100"></el-table-column>
        <el-table-column label="关联教师" min-width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.TeacherId" type="primary" size="mini" effect="plain">{{ scope.row.TeacherName }}</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="DepartmentName" label="所属学校" min-width="120"></el-table-column>
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.Enabled ? 'success' : 'danger'" size="small">
              {{ scope.row.Enabled ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="Remark" label="备注" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="CreateTime" label="创建时间" width="165" align="center"></el-table-column>
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="warning" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <div class="pagination-container">
        <el-pagination
          layout="total, prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          style="float: right">
        </el-pagination>
      </div>

      <!--新增/编辑弹窗-->
      <el-dialog :title="dialogTitle" :visible.sync="editFormVisible" width="440px"
        :close-on-click-modal="false" destroy-on-close>
        <el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="90px">
          <el-form-item label="教职工" prop="TeacherId">
            <div class="ps-pick-summary">
              <span v-if="editForm.TeacherId">
                已选 <strong>{{ selectedPersonLabel || ('教职工#' + editForm.TeacherId) }}</strong>
              </span>
              <span v-else class="muted-text">请选择一名教职工</span>
              <el-button type="primary" size="mini" plain @click="openPersonPicker">选择教职工</el-button>
              <el-button v-if="editForm.TeacherId" type="text" size="mini" @click="clearTeacherPick">清空</el-button>
            </div>
            <div class="form-tip">从通讯录选择，仅绑定一人</div>
          </el-form-item>
          <el-form-item label="姓名" prop="Name">
            <el-input v-model="editForm.Name" maxlength="50" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="启用状态">
            <el-switch v-model="editForm.Enabled"></el-switch>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="editForm.Remark" :rows="3" maxlength="500"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="editFormVisible = false">取消</el-button>
          <el-button type="primary" :loading="editLoading" @click="editSubmit">确定</el-button>
        </div>
      </el-dialog>

      <person-scope-picker-dialog
        :visible.sync="personPickerVisible"
        directory-scope="internal"
        :show-scope-tabs="false"
        :scope-department-id="DepartmentId"
        :value="editForm.TeacherId"
        :label="selectedPersonLabel"
        @confirm="onPersonPicked"
      />
    </section>
  </section>
</template>

<script>
import { getRepairAdminListPage, addRepairAdmin, editRepairAdmin, removeRepairAdmin } from '../../api/modules/repair';
import { getButtonList } from '../../promissionRouter';
import Toolbar from '../../components/Toolbar';
import DepartmentPane from '../../components/DepartmentPane';
import PersonScopePickerDialog from '../../components/PersonScopePickerDialog';

export default {
  components: { Toolbar, DepartmentPane, PersonScopePickerDialog },
  data() {
    return {
      searchList: [{ label: '姓名', key: 'name' }],
      filters: {},
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      buttonList: [],
      DepartmentId: 0,

      dialogTitle: '',
      editFormVisible: false,
      editLoading: false,
      personPickerVisible: false,
      selectedPersonLabel: '',
      editFormRules: {
        TeacherId: [{ required: true, message: '请选择教职工', trigger: 'change' }],
        Name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
      },
      editForm: {
        Id: 0,
        DepartmentId: 0,
        TeacherId: null,
        Name: '',
        Enabled: true,
        Remark: ''
      }
    };
  },

  methods: {
    treeNodeClick(data) {
      this.DepartmentId = data.value;
      this.page = 1;
      this.getList();
    },

    getList() {
      const para = {
        page: this.page,
        intPageSize: this.pageSize,
        departmentId: this.DepartmentId || 0,
        ...this.filters
      };
      this.listLoading = true;
      getRepairAdminListPage(para).then(res => {
        this.listLoading = false;
        if (res.data && res.data.success && res.data.response) {
          this.tableData = res.data.response.data || [];
          this.total = res.data.response.dataCount || 0;
        }
      }).catch(() => { this.listLoading = false; });
    },

    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },

    callFunction(item) {
      if (typeof item.search === 'object') {
        this.filters = item.search;
      } else {
        this.filters = { name: item.search };
      }
      this[item.Func] && this[item.Func].apply(this, item);
    },

    handleQuery() {
      this.page = 1;
      this.getList();
    },

    handleAdd() {
      if (!this.DepartmentId || this.DepartmentId === 0) {
        this.$message.warning('请先在左侧选择学校！');
        return;
      }
      this.dialogTitle = '新增报修管理员';
      this.selectedPersonLabel = '';
      this.editForm = { Id: 0, DepartmentId: this.DepartmentId, TeacherId: null, Name: '', Enabled: true, Remark: '' };
      this.editFormVisible = true;
      this.$nextTick(() => { this.$refs.editForm && this.$refs.editForm.clearValidate(); });
    },

    handleEdit(row) {
      this.dialogTitle = '编辑报修管理员';
      this.editForm = Object.assign({}, row);
      this.editForm.DepartmentId = row.DepartmentId || this.DepartmentId;
      this.selectedPersonLabel = row.TeacherName || '';
      this.editFormVisible = true;
      this.$nextTick(() => { this.$refs.editForm && this.$refs.editForm.clearValidate(); });
    },

    handleDel(row) {
      this.$confirm('确认删除该报修管理员吗？', '提示', { type: 'warning' }).then(() => {
        this.listLoading = true;
        removeRepairAdmin({ id: row.Id }).then(res => {
          this.listLoading = false;
          if (res.data && res.data.success) {
            this.$message.success('删除成功');
            this.getList();
          } else {
            this.$message.error(res.data.msg || '删除失败');
          }
        }).catch(() => { this.listLoading = false; });
      });
    },

    /** 打开内部通讯录单选教职工。创建于 2026-09-23 */
    openPersonPicker() {
      if (!this.DepartmentId) {
        this.$message.warning('请先在左侧选择学校！');
        return;
      }
      this.personPickerVisible = true;
    },
    clearTeacherPick() {
      this.editForm.TeacherId = null;
      this.selectedPersonLabel = '';
      this.$nextTick(() => {
        if (this.$refs.editForm) this.$refs.editForm.validateField('TeacherId');
      });
    },
    onPersonPicked(person) {
      if (!person) return;
      this.editForm.TeacherId = person.id;
      this.selectedPersonLabel = person.name || '';
      if (person.name) this.editForm.Name = person.name;
      this.$nextTick(() => {
        if (this.$refs.editForm) this.$refs.editForm.validateField('TeacherId');
      });
    },

    editSubmit() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return;
        this.editLoading = true;
        const apiCall = this.editForm.Id > 0 ? editRepairAdmin : addRepairAdmin;
        apiCall(Object.assign({}, this.editForm)).then(res => {
          this.editLoading = false;
          if (res.data && res.data.success) {
            this.$message.success('保存成功');
            this.editFormVisible = false;
            this.getList();
          } else {
            this.$message.error(res.data.msg || '保存失败');
          }
        }).catch(() => { this.editLoading = false; });
      });
    }
  },

  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  }
};
</script>

<style scoped>
.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
.form-tip {
  color: #909399;
  font-size: 12px;
  line-height: 1.4;
  margin-top: 6px;
}
.muted-text {
  color: #94a3b8;
}
.ps-pick-summary {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  color: #475569;
  font-size: 13px;
}
</style>
